export interface ChartPalette {
  id: string
  label: string
  primaryIndex: number
  colors: readonly [string, string, string, string, string, string, string]
}

export const DEFAULT_CHART_PALETTE_ID = 'forest' as const

export const CHART_PALETTES: Readonly<Record<string, ChartPalette>> = {
  forest: {
    id: 'forest',
    label: 'Forest',
    primaryIndex: 3,
    colors: [
      '164 86% 16%',
      '163 88% 20%',
      '163 94% 24%',
      '161 94% 30%',
      '160 84% 39%',
      '158 64% 52%',
      '156 72% 67%',
    ],
  },
  ocean: {
    id: 'ocean',
    label: 'Ocean',
    primaryIndex: 3,
    colors: [
      '202 80% 24%',
      '201 96% 32%',
      '200 98% 39%',
      '199 89% 48%',
      '198 93% 60%',
      '199 95% 74%',
      '201 94% 86%',
    ],
  },
  slate: {
    id: 'slate',
    label: 'Slate',
    primaryIndex: 3,
    colors: [
      '217 33% 17%',
      '215 25% 27%',
      '215 19% 35%',
      '215 16% 47%',
      '215 20% 65%',
      '213 27% 84%',
      '214 32% 91%',
    ],
  },
  earth: {
    id: 'earth',
    label: 'Earth',
    primaryIndex: 3,
    colors: [
      '88 61% 20%',
      '86 69% 23%',
      '86 78% 27%',
      '85 85% 35%',
      '84 81% 44%',
      '83 78% 55%',
      '81 88% 80%',
    ],
  },
  mint: {
    id: 'mint',
    label: 'Mint',
    primaryIndex: 3,
    colors: [
      '163 88% 20%',
      '163 94% 24%',
      '161 94% 30%',
      '160 84% 39%',
      '158 64% 52%',
      '156 72% 67%',
      '152 76% 80%',
    ],
  },
  autumn: {
    id: 'autumn',
    label: 'Autumn',
    primaryIndex: 3,
    colors: [
      '21 92% 14%',
      '22 78% 26%',
      '23 82% 31%',
      '26 90% 37%',
      '32 95% 44%',
      '38 92% 50%',
      '43 96% 56%',
    ],
  },
  sunset: {
    id: 'sunset',
    label: 'Sunset',
    primaryIndex: 3,
    colors: [
      '15 75% 28%',
      '15 79% 34%',
      '17 88% 40%',
      '21 90% 48%',
      '25 95% 53%',
      '27 96% 61%',
      '31 97% 72%',
    ],
  },
  coral: {
    id: 'coral',
    label: 'Coral',
    primaryIndex: 3,
    colors: [
      '342 75% 30%',
      '343 80% 35%',
      '335 78% 42%',
      '333 71% 51%',
      '330 81% 60%',
      '329 86% 70%',
      '326 85% 90%',
    ],
  },
  lavender: {
    id: 'lavender',
    label: 'Lavender',
    primaryIndex: 3,
    colors: [
      '263 69% 42%',
      '263 70% 50%',
      '262 83% 58%',
      '258 90% 66%',
      '255 92% 76%',
      '252 95% 85%',
      '250 95% 92%',
    ],
  },
  twilight: {
    id: 'twilight',
    label: 'Twilight',
    primaryIndex: 3,
    colors: [
      '242 47% 34%',
      '244 55% 41%',
      '245 58% 51%',
      '243 75% 59%',
      '239 84% 67%',
      '234 89% 74%',
      '230 94% 82%',
    ],
  },
  berry: {
    id: 'berry',
    label: 'Berry',
    primaryIndex: 3,
    colors: [
      '336 69% 30%',
      '343 80% 35%',
      '335 78% 42%',
      '333 71% 51%',
      '330 81% 60%',
      '329 86% 70%',
      '327 87% 82%',
    ],
  },
  colorful: {
    id: 'colorful',
    label: 'Colorful',
    primaryIndex: 3,
    colors: [
      '221 83% 53%',
      '160 84% 39%',
      '38 92% 50%',
      '0 84% 60%',
      '258 90% 66%',
      '330 81% 60%',
      '189 94% 43%',
    ],
  },
} as const

export const CHART_PALETTE_IDS = Object.keys(CHART_PALETTES)

export function getChartPalette(id: string | null | undefined): ChartPalette {
  return CHART_PALETTES[id ?? ''] ?? CHART_PALETTES[DEFAULT_CHART_PALETTE_ID]
}
